import React from 'react';
import './MaintenancePage.scss';

const Icon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 199 205">
      <defs>
        <linearGradient id="zvw4suyqma" x1="128.709%" x2="-2.463%" y1="-8.464%" y2="115.877%">
          <stop offset="0%" stopColor="#ffffff"/>
          <stop offset="100%" stopColor="#ffffff"/>
        </linearGradient>
        <linearGradient id="6j2yqy0tfb" x1="129.393%" x2="-2.919%" y1="-8.464%" y2="115.877%">
          <stop offset="0%" stopColor="#ffffff"/>
          <stop offset="100%" stopColor="#ffffff"/>
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g fill="none" strokeWidth="4">
          <g>
            <path stroke="url(#zvw4suyqma)" d="M187.332 170.783c.134-1.072.234-2.144.234-3.283 0-1.139-.1-2.211-.234-3.283l7.05-5.528c.635-.502.802-1.406.401-2.143l-6.682-11.591c-.401-.738-1.303-1.006-2.038-.738l-8.32 3.35c-1.737-1.34-3.608-2.445-5.646-3.282l-1.27-8.878c-.1-.804-.802-1.407-1.637-1.407h-13.365c-.835 0-1.537.603-1.637 1.407l-1.27 8.877c-2.038.838-3.909 1.977-5.646 3.284l-8.32-3.35c-.768-.302-1.637 0-2.038.737l-6.682 11.59c-.435.738-.234 1.642.4 2.145l7.05 5.527c-.133 1.072-.233 2.177-.233 3.283 0 1.106.1 2.211.233 3.283l-7.05 5.528c-.634.502-.801 1.406-.4 2.143l6.682 11.591c.4.738 1.303 1.006 2.038.738l8.32-3.35c1.737 1.34 3.608 2.445 5.646 3.282l1.27 8.878c.1.804.802 1.407 1.637 1.407h13.365c.835 0 1.537-.603 1.637-1.407l1.27-8.877c2.038-.838 3.909-1.977 5.646-3.284l8.32 3.35c.768.302 1.637 0 2.038-.737l6.682-11.59c.401-.738.234-1.642-.4-2.145l-7.05-5.527h0zm-24.832 8.403c-6.431 0-11.663-5.242-11.663-11.686s5.232-11.686 11.663-11.686 11.663 5.242 11.663 11.686-5.232 11.686-11.663 11.686h0z" transform="translate(-60 -118) translate(62 120)"/>
            <path stroke="url(#6j2yqy0tfb)" d="M134.07 85.644c.312-2.496.546-4.992.546-7.644s-.234-5.148-.547-7.644l16.486-12.87c1.485-1.17 1.875-3.276.938-4.992l-15.627-26.988c-.937-1.716-3.047-2.34-4.766-1.716l-19.455 7.8c-4.062-3.12-8.438-5.694-13.204-7.644l-2.969-20.67C95.238 1.404 93.597 0 91.644 0H60.39c-1.953 0-3.594 1.404-3.829 3.276l-2.969 20.67c-4.766 1.95-9.141 4.602-13.204 7.644l-19.455-7.8c-1.797-.702-3.828 0-4.766 1.716L.542 52.494c-1.016 1.716-.547 3.822.937 4.992l16.486 12.87c-.312 2.496-.547 5.07-.547 7.644s.235 5.148.547 7.644L1.48 98.514c-1.484 1.17-1.875 3.276-.937 4.992l15.626 26.988c.938 1.716 3.047 2.34 4.766 1.716l19.455-7.8c4.063 3.12 8.438 5.694 13.204 7.644l2.97 20.67c.234 1.872 1.875 3.276 3.828 3.276h31.253c1.953 0 3.594-1.404 3.828-3.276l2.97-20.67c4.765-1.95 9.14-4.602 13.203-7.644l19.455 7.8c1.797.702 3.829 0 4.766-1.716l15.627-26.988c.937-1.716.547-3.822-.938-4.992l-16.486-12.87h0zM76 105.209c-15.039 0-27.273-12.205-27.273-27.209S60.961 50.79 76 50.79 103.273 62.997 103.273 78c0 15.004-12.234 27.21-27.273 27.21h0z" transform="translate(-60 -118) translate(62 120)"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

const MaintenancePage = () => {
  return (
    <div className="MaintenancePage" data-testid="MaintenancePage">
      <div className="empty-container alert-box">
        <div className="empty-icon">
          <div style={{padding: 20}}>
            <Icon />
          </div>
        </div>
        <h3 className="data-text-empty"><strong className="font-semi-bold mb-5">Il sito è in manutenzione. </strong> <br/>
          Riprova più tardi.</h3>
      </div>
    </div>
  )
};

MaintenancePage.propTypes = {};

export default MaintenancePage;
